import React from "react";
import { SellableProductIcon, BundleIcon } from "../../../assets/icons/index";

import { ISellableProduct } from "../../../model/interface/sellableProduct";
import { IBundleList } from "../../../model/interface/bundle";
import constant from "../../../utils/constant";
import { Link } from "react-router";

const AccordionBundles: React.FC<any> = ({
  bundles,
  sellableProducts,
}: {
  bundles: IBundleList[];
  sellableProducts: ISellableProduct[];

  addProductAction: (eventType: boolean) => void;
  addBundleAction: (eventType: boolean) => void;
  productRedirectAction: (productId: number) => void;
  bundleRedirectAction: (bundleId: number) => void;
}) => {
  return (
    <>
      <div className="grid grid-cols-1 justify-between">
        <div className="px-3 py-3 shadow-lg border rounded-lg dark:text-white">
          <div className="flex justify-between">
            <div className="flex w-full justify-between items-center mt-1 mb-4 rounded-lg">
              Sellable Products
            </div>
          </div>

          <div
            key={"1"}
            className={`flex py-3 px-3 mb-2  rounded-lg bg-white border`}
          >
            <div className="w-full">
              <div id="productList" className="h-auto">
                {sellableProducts.map((product) => (
                  <div
                    key={product.sellableProductId}
                    className="flex items-start border-b pb-2 mb-2 border-gray-200"
                  >
                    <div className="flex items-start">
                      <div className="flex-none h-4 w-4 mt-0.5">
                        <SellableProductIcon />
                      </div>

                      <Link
                        className="ml-2 cursor-pointer font-medium  hover:underline text-primary-color dark:text-white"
                        to={constant.MANAGESELLABLEPRODUCT.replace(
                          ":id",
                          product?.sellableProductId?.toString() || ""
                        )}
                      >
                        {product.sellableProductName}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="hidden mt-5 px-3 py-3 shadow-lg border rounded-lg dark:text-white">
          <div className="flex justify-between">
            <div className="flex w-full justify-between items-center mt-1 mb-4 rounded-lg">
              Bundles
            </div>
          </div>

          <div
            key={"1"}
            className={`flex py-3 px-3 mb-2  rounded-lg bg-white border`}
          >
            <div className="w-full">
              <div id="bundleList" className="h-auto">
                {bundles.map((bundle) => (
                  <div
                    key={bundle.id}
                    className="flex items-start border-b pb-2 mb-2 border-gray-200"
                  >
                    <div className="flex-none h-4 w-4 mt-0.5">
                      <BundleIcon />
                    </div>

                    <div className="flex items-center">
                      <Link
                        className="ml-2 cursor-pointer font-medium  hover:underline text-primary-color dark:text-white"
                        to={constant.EDITBUNDLES.replace(
                          ":id",
                          bundle.id.toString()
                        )}
                      >
                        {bundle.name}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccordionBundles;
